/**
 * UploadController
 */

function initializeUpload(
        idInput,
        text1,
        text2,
        msgRenameFile,
        msgNoFile,
        lblTraitementEnCours,
        lblRecupererFichier,
        lblNon,
        lblOui,
        nomTable,
        bddIndex,
        nomChamp,
        sExport
        ) {
    require(["bootbox", "eservicesController", "jquery.uniform", "jquery-form"], function (bootbox) {
        var newName = "";
        $("#upload_" + idInput).uniform({
            fileButtonHtml: $("<div/>").html(text1).text(),
            fileDefaultHtml: $("<div/>").html(text2).text()
        });
        var progress = $("#progress_" + idInput);
        var bar = $("#bar_" + idInput);
        var percent = $("#percent_" + idInput);
        $("#formSaisie_" + idInput).ajaxForm({
            beforeSubmit: function () {
                if ($("#upload_" + idInput).val() == "") {
                    bootbox.alert(msgNoFile);
                    return false;
                } else {
                    return true;
                }
            },
            beforeSend: function () {
//                    if(_IS_IE10_OR_NON_IE){
                bar.width("0%");
                percent.html("0%");
//                    }
//                    else {
//                        progress_+idInput+.css("text-align", "center").html(\'<img src="style/loadingBar.gif" style="width: 100%; height: 20px;">\');
//                    }
            },
            uploadProgress: function (event, position, total, percentComplete) {
//                    if(_IS_IE10_OR_NON_IE){
                var percentVal = percentComplete + "%";
                bar.width(percentVal);
                percent.html(percentVal);
                if (percentComplete >= 95) {
                    $("#listeFichiers_" + idInput).html("<div class=\"alert alert-info\"><i class=\"icon-spinner icon-spin\"></i>" + lblTraitementEnCours + "</div>");
                }
//                    }
            },
            success: function (responseText) {
                var myObject = responseText;
                if (myObject.result == true) {
                    $("#listeFichiers_" + idInput).html("<div class=\"alert alert-success\">" + lblRecupererFichier + "</div>");
//                        if(!_IS_IE10_OR_NON_IE){
                    progress.text("Uploaded");
//                        }
//                        else{
//                            bar_+idInput+.width("100%");
//                            percent_+idInput+.html("100%");
//                        }

                    ProcessUpdate(nomTable, bddIndex, nomChamp, myObject.message, sExport, true);
                } else {
                    if (myObject.result == false && myObject.code == "FILE_EXISTS") {
                        newName = myObject.message;
                        $("#listeFichiers_" + idInput).html(
                                "<div class=\"alert alert-warning\">"
                                + msgRenameFile.replace("%1", myObject.message)
                                + "<div class=\"btn-group\">"
                                + "<button class=\"btn btn-primary\" onclick=\"callbackRenameUpload(\'" + idInput + "\', \'" + myObject.message + "\');\">" + lblOui + "</button>"
                                + "<button class=\"btn btn-primary\" onclick=\"Seed.Tab.Reload();\">" + lblNon + "</button>"
                                + "</div>"
                                + "</div>"
                                );
                    } else {
                        $("#listeFichiers_" + idInput).html("<div class=\"alert alert-danger\">" + myObject.message + "</div>");
                    }
                }
            }
        });
    });
}

function getAdvencedParam()
{
    require(['Seed', "Seed.Import"], function (Seed) {
        Seed.Import.getAdvencedParam();
    });
}

/**
 * Fonction de callback pour le rennomage d'un fichier uploadé
 * Fonctionne principalement sur le model des fonctions de IO::
 * @param {type} idInput
 * @param {type} fileName
 * @returns {undefined}
 */
function callbackRenameUpload(idInput, fileName)
{
    $('#forceName_' + idInput).val(fileName);
    $('#formSaisie_' + idInput).submit();
};
define("uploadController", function(){});

